import Vue from 'vue'
import VueI18n from 'vue-i18n'
import common from './pt_BR/common'


const DEFAULT = 'pt_BR';

const messages = {
    [DEFAULT]: {
        common: common
    }
};

Vue.use(VueI18n, {
    lang: DEFAULT,
    messages
});

export default new VueI18n({
    locale: DEFAULT,
    messages
});
